/* eslint-disable no-undef */
import userApi from '@api/userApi';

const createTokenProvider = () => {

  let token = JSON.parse(localStorage.getItem('REACT_TOKEN_AUTH') || 'null') || null;
  let observers = [];

  const getExpirationDate = (jwtToken) => {

    if (!jwtToken) return null;

    const jwt = JSON.parse(atob(jwtToken.split('.')[1]));
    return (jwt && jwt.exp && jwt.exp * 1000) || null;

  };

  const isExpired = (exp) => {

    if (!exp) return false;
    return Date.now() > exp;

  };

  const isLoggedIn = () => !!token;

  const notify = () => {

    const isLogged = isLoggedIn();
    observers.forEach((observer) => observer(isLogged));

  };

  const setToken = (newToken) => {

    if (newToken) {

      localStorage.setItem('REACT_TOKEN_AUTH', JSON.stringify(newToken));

    } else {

      localStorage.removeItem('REACT_TOKEN_AUTH');

    }

    token = newToken;
    notify();

  };

  const getToken = async () => {

    if (!token) return null;
    const { accessToken, refreshToken } = token;

    if (isExpired(getExpirationDate(accessToken))) {

      let resUpdatedToken;
      try {

        resUpdatedToken = await userApi.refresh(refreshToken);

      } catch (error) {

        // eslint-disable-next-line no-console
        console.log('error: ', error);
        return setToken(null);

      }
      const {
        access_token, token_type, refresh_token,
      } = resUpdatedToken;
      setToken({
        accessToken: access_token, tokenType: token_type, refreshToken: refresh_token,
      });

    }

    return token && token.accessToken;

  };

  const subscribe = (observer) => {

    observers.push(observer);

  };

  const unsubscribe = (observer) => {

    observers = observers.filter((_observer) => _observer !== observer);

  };

  return {
    getToken,
    isLoggedIn,
    setToken,
    subscribe,
    unsubscribe,
  };

};

export default createTokenProvider();
